export default __webpack_public_path__ + "static/SpotDark-fd7ddddc5b243ce5b80fc1e8a8a0fa68.png";